<template>
<el-row type="flex" align="middle">
  <el-row type="flex" justify="space-between" align="middle" class="header-menu">
    <div class="logo" @click="onLogoClick" :class="{ 'pointer': hasCandidateRole }"></div>
    <el-menu
      v-if="menus && menus.length"
      :default-active="activeIndex"
      mode="horizontal"
      router
      :default-openeds="['Cover']"
      menu-trigger="click"
    >
      <div v-for="item in menus" :key="item.path">
        <el-submenu
          v-if="item.children"
          :index="item.path"
          :popper-append-to-body="false"
          popper-class="submenu"
          class="menu-item"
        >
          <template slot="title">{{ item.meta.title }}</template>
          <el-menu-item
            v-for="subMenu in item.children"
            :key="subMenu.name"
            :index="`${item.path}/${subMenu.path}`"
            >{{ subMenu.meta.title }}</el-menu-item
          >
        </el-submenu>
        <el-menu-item
          v-if="!item.children && !item.meta.hidden"
          :key="item.name"
          :index="item.path"
          class="menu-item"
        >
          {{ item.meta.title }}
        </el-menu-item>
      </div>
    </el-menu>
    <el-row type="flex" align="middle">
      <!-- <div class="icon icon-help pointer"></div> -->
      <el-button v-if="showHomeLink" type="text" class="menu-link" style="margin-right: 16px;" @click="$router.push('/')">首页</el-button>
      <el-row v-if="isCandidatePage" type="flex" align="middle" class="btn-recruit" @click.native="onRedirectRecruitClick">
        <i class="icon icon-recruit"></i>
        <div>我是招聘方</div>
      </el-row>
      <el-dropdown
        v-if="hasCandidateRole"
        trigger="click"
        placement="bottom-start"
        class="share"
      >
        <div class="el-dropdown-link">分享</div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item class="icon-hyperlink" @click.native.prevent="handleShareClick">
            分享链接
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown
        v-if="isLogin"
        trigger="click"
        placement="bottom-start"
        class="profile"
      >
        <span class="el-dropdown-link">{{ userName }}<i class="el-icon-arrow-down el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="role.includes($roleEnum.CANDIDATE.name)" class="my-resume">
            <router-link :to="{ name: 'MyResume' }">我的简历</router-link>
          </el-dropdown-item>
          <el-dropdown-item v-if="role.includes($roleEnum.CANDIDATE.name)" class="deliver-record">
            <router-link :to="{ name: 'DeliverRecord' }">投递记录</router-link>
          </el-dropdown-item>
          <el-dropdown-item v-if="!hasCandidateRole" class="info" @click.native="handleEditInfo"
            >修改信息</el-dropdown-item
          >
          <el-dropdown-item v-if="!hasCandidateRole" class="pwd" @click.native="showEditPassword = true"
            >修改密码</el-dropdown-item
          >
          <el-dropdown-item class="logout" @click.native="handleLogout"
            >退出登录</el-dropdown-item
          >
          <el-dropdown-item v-if="hasCandidateRole" class="user-remove" @click.native="handleCancellation"
            >注销账号</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <el-button v-else type="text" @click="handleLogin" class="btn-login"
        >登录</el-button
      >
      <i v-if="!isCandidatePage && hasRecruitRole && helpFileUrl" title="使用指引" class="help icon icon-question" @click="$utils.previewPdf(helpFileUrl)"></i>
    </el-row>
  </el-row>
    <RegisterAndLogin
      v-if="showRegisterAndLogin"
      :visible.sync="showRegisterAndLogin"
      :type="registerAndLoginType"
    />
    <EditInfo :visible.sync="showEditInfo" />
    <EditPassword2 :visible.sync="showEditPassword" />
</el-row>
</template>

<script>
import { mapGetters } from "vuex";
import RegisterAndLogin from "@/components/RegisterAndLogin.vue";
import EditInfo from "@/components/EditInfo.vue";
import EditPassword2 from "@/components/EditPassword2.vue";

export default {
  components: {
    RegisterAndLogin,
    EditInfo,
    EditPassword2,
  },

  props: {},

  data() {
    return {
      showRegisterAndLogin: false,
      registerAndLoginType: "",
      showEditInfo: false,
      showEditPassword: false,
      helpFileUrl: '', // 帮助指引文件url
    };
  },

  computed: {
    activeIndex({ $route }) {
      return $route.meta.activePath || $route.path
    },
    menus({ $store }) {
      let routes = $store.state.user.routes;
      if (!routes) return [];
      return routes
        .reduce((pre, cur) => {
          if (!cur.meta.hidden) {
            pre.push(cur.children ? {
              ...cur,
              children: cur.children.filter(item => !item.meta.hidden)
            } : cur)
          }
          return pre
        }, [])
    },
    phone({ $store }) {
      let userInfo = $store.state.user.userInfo;
      return (
        (userInfo &&
          `${userInfo.phone.slice(0, 3)}****${userInfo.phone.slice(7)}`) ||
        undefined
      );
    },
    userName({ $store, hasCandidateRole }) {
      let { userName, phone } = $store.state.user.userInfo || {}
      return hasCandidateRole ? `${phone.slice(0, 4)}****${phone.slice(-3)}` : userName
    },
    isLogin({ $store }) {
      return $store.state.user.token;
    },
    role({ $store }) {
      return $store.state.user.role;
    },
    // 是否显示首页链接
    showHomeLink({ $route, role, $roleEnum }) {
      return $route.meta.showHomepageLink
    },
    // 是否为应聘人员页面
    isCandidatePage({ $route }) {
      return $route.meta.isCandidatePage
    },
    hasCandidateRole({ $route, $roleEnum }) {
      return this.$utils.hasRole($route, $roleEnum.CANDIDATE.name)
    },
    ...mapGetters('user', [
      'hasRecruitRole',
    ]),
  },

  watch: {
    "$store.state.form.showLogin": {
      handler(val) {
        console.log('watch',val);
        this.showRegisterAndLogin = val;
      },
    },
  },

  created() {
    this.getHelpFile()
  },

  methods: {
    handleLogin() {
      this.registerAndLoginType = "login";
      this.hasCandidateRole ? this.$store.commit("form/SET_SHOW_LOGIN", true) : this.$router.push({ name: 'Login' });
    },
    // 修改信息
    handleEditInfo() {
      this.showEditInfo = true
    },
    async handleLogout() {
      let { code, msg } = await this.$api.logout();
      if (code === 200) {
        msg = "您已退出登录，有空常来逛逛~";
        this.$message.success(msg);
        this.$store.dispatch("user/logout", { diableGetAuth: true });
        setTimeout(() => {
          this.$router.push('/')
        }, 2000)
      }
    },

    async handleCancellation() {
      this.$confirm('注销账号后，您的账号及数据将被全部删除。请确认是否注销？', '', {
        type: "warning",
      })
        .then(async ()=>{
      let { code, msg } = await this.$api.cancellation();
      // let { code, msg } = await this.$api.logout();
      if (code === 200) {
        // let { code, msg } = await this.$api.logout();
        msg = "您已注销账号\n，期待有机会再与您相遇~";
        this.$message.success(msg);
        this.$store.dispatch("user/logout", { diableGetAuth: true });
        setTimeout(() => {
          this.$router.push('/')
        }, 2000)
      }
        })
        .catch(()=>{})
    },
    handleShareClick() {
      let {
        origin,
        pathname,
      } = location

      // 分享链接的地址为应聘者首页
      this.$utils.setClipboard(origin + pathname + '#/collegeRecruit') && this.$message.success('链接已复制，快去分享吧~')
    },
    onLogoClick() {
      this.hasCandidateRole && this.$router.push('/')
    },
    // 获取使用指引的文件
    async getHelpFile() {
      let { data } = await this.$api.queryPicture()
      let arr = data.reduce((pre, cur) => {
        if (cur.fileType === this.$fileUploadTypeEnum.HELP) {
          pre.push(cur.pictureUrl)
        }
        return pre
      }, [])
      this.helpFileUrl = arr[0]
    },
    // 跳转招聘人员页面
    async onRedirectRecruitClick() {
      if (this.isLogin) {
        let { code } = await this.$api.logout();
        if (code === 200) {
          this.$store.dispatch("user/logout", { diableGetAuth: true });
        }
      }
      this.$router.push({ name: 'Login' })
    },
  },
};
</script>

<style lang="scss" scoped>
$menu-btn-height: 51px;

.header-menu {
  flex: 1;
}
.logo {
  // margin-right: 190px;
  width: 196px;
  height: 62px;
  background: url("~@/assets/image/logo.png");
}
.el-menu {
  box-sizing: border-box;
  flex: 1;
  display: flex;
  justify-content: space-between;
  height: 80px;
  background-color: transparent;
  &::before,
  &::after {
    content: '';
    display: block;
  }
  .el-menu-item,
  .el-submenu /deep/.el-submenu__title {
    // margin-right: 120px;
    padding: 0;
    height: $menu-btn-height;
    line-height: $menu-btn-height;
    @extend .f24;
    font-weight: 600;
    color: #323233;
    background: transparent;
    &:hover {
      background: transparent;
    }

    .el-submenu__icon-arrow {
      display: none;
    }
  }
  .el-submenu {
    height: $header-height;
    &.is-active {
      @extend .menu-item;
      /deep/.el-submenu__title {
        // margin: 0 20px;

        .el-submenu__icon-arrow {
          display: none;
        }
      }
    }
    /deep/ .submenu {
      display: flex;
      justify-content: center;
      width: 96px;
      transform: translateX(36px);
      .el-menu--popup {
        margin: 0;
        min-width: auto;
        .el-menu-item {
          min-width: auto;
          @extend .f16;
        }
      }
    }
  }
  .menu-item {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    width: 158px;
    height: $menu-btn-height;
    line-height: $menu-btn-height;
    border-radius: 56px;
    background: transparent;
    text-align: center;
    z-index: 3;
    &.is-active {
      color: #fff;
      background: #409EFF;
      &.el-menu-item:not(.is-disabled) {
        &:focus,
        &:hover {
          color: #fff;
        }
      }
      /deep/ .el-submenu__title {
        color: #fff;
      }
    }
  }
}
.submenu {
  .el-menu {
    min-width: 300px;
    width: 133px;
    .el-menu-item {
      margin-right: 0;
      width: 133px;
      height: 36px;
      line-height: 36px;
      @extend .f14;
      color: #606266;
      text-align: center;
      &.is-active {
        border-bottom: none;
      }
      &:hover {
        color: #fff;
        background: #99cafc;
      }
    }
  }
}
.menu-link {
  margin-right: 2px;
  @extend .f18;
  color: #323233;
}
.icon {
  &-help {
    margin-right: 17px;
  }
}
.share {
  margin-right: 17px;
  @extend .f18;
  color: #323233;
  cursor: pointer;
  .el-dropdown-link {
    white-space: nowrap;
  &::before {
    content: "";
    display: inline-block;
    margin-right: 6px;
    width: 18px;
    height: 18px;
    background: url("~@/assets/icon/share.png") center/100%;
    vertical-align: text-top;
  }
  }
}
.btn {
  &-login {
    @extend .f18;
    color: #323233;
    &::before {
      content: "";
      display: inline-block;
      margin-right: 6px;
      width: 18px;
      height: 18px;
      background: url("~@/assets/icon/user.png") center/100%;
      vertical-align: top;
    }
  }
  &-recruit {
    margin-right: 20px;
    font-size: 18px;
    cursor: pointer;
    &::before {
      margin-right: 6px;
    }
  }
}
.profile {
  height: 100%;
  @extend .f18;
  color: #323233;
  cursor: pointer;
  &::before {
    content: "";
    display: inline-block;
    margin-right: 6px;
    width: 18px;
    height: 18px;
    background: url("~@/assets/icon/user.png") center/100%;
    vertical-align: text-top;
  }
}
.help {
  margin-left: 24px;
  cursor: pointer;
}
.el-dropdown-menu {
  .el-dropdown-menu__item {
    padding: 10px 20px;
    @extend .f16;
    line-height: 1;
    white-space: nowrap;
    &::before {
      content: "";
      display: inline-block;
      margin-right: 6px;
      width: 18px;
      height: 18px;
      background-image: url("~@/assets/icon/record.png");
      vertical-align: top;
    }
    &.icon-hyperlink {
      &::before {
        background-image: url("~@/assets/icon/hyperlink.png");
      }
    }
    &.my-resume {
      &::before {
        background-image: url("~@/assets/icon/resume.png");
      }
    }
    &.deliver-record {
      &::before {
        background-image: url("~@/assets/icon/record.png");
      }
    }    
    &.info {
      &::before {
        height: 19px;
        background-image: url("~@/assets/icon/profile.png");
      }
    }
    &.pwd {
      &::before {
        height: 18px;
        background-image: url("~@/assets/icon/lock_black.png");
        background-size: 100%;
      }
    }
    &.logout {
      &::before {
        background-image: url("~@/assets/icon/exit.png");
      }
    }
    &.user-remove {
      &::before {
        background-image: url("~@/assets/icon/user_remove.png");
      }
    }
    .el-dropdown-menu__item {
      padding: 10px 20px;
    }
  }
  a {
    color: rgba(0, 0, 0, 0.65);
    text-decoration: none;
    &:hover {
      color: #66b1ff;
    }
  }
}
</style>
